/**
 *   Copyright (C) Cylergie - All Rights Reserved
 * Proprietary and confidential
 * Subject to French law on copyright
 * Unauthorized copying of this file, via any medium is strictly prohibited: https://crigen.myengie.com/copyright
 * Any request for authorization of use should be addressed by email to"mvalo.bvt@engie.com" with the subject "Copyright Statement in Source Code"
 * Written in 2026
 */

/* eslint-disable */

import * as configApi from '@/services/api/configuration';
import * as predictionsApi from '@/services/api/predictions';

export default {
  namespaced: true,

  state: {
    currentStep: 1,
    maxStep: 1,

    // Sélection (Step 1)
    selectedTerritory: null,
    selectedEntity: null,
    selectedAsset: null,
    selectedAssetId: null,
    assetName: '', // Nom du site pour affichage dans context-bar

    // Mode (Step 2)
    mode: null, // 'config' ou 'predictions'

    // Configuration (Steps 3-5 mode config)
    heatingPlantId: null, // ID du HeatingPlant pour sauvegarder
    silos: [],
    boilers: [],
    pilotMode: null,
    regulationMode: null,
    cogenActive: null,
    cogenPower: null,
    tagPrevision: null,

    // Prévisions (Steps 3-5 mode predictions)
    initialStocks: [],
    constraints: [],
    planningData: [],
    planningTimestamp: null,
    planningConfig: {
      startDate: null,
      endDate: null,
      temperatureScenario: 'normal',
    },

    // UI states
    isAssetReady: false,
    isModeReady: false,
    isConfigComplete: false,
    notification: {
      show: false,
      message: '',
      type: 'info', // 'info', 'success', 'warning', 'error'
    },
  },

  mutations: {
    SET_STEP(state, step) {
      state.currentStep = step;
      if (step > state.maxStep) state.maxStep = step;
    },

    SET_TERRITORY(state, payload) {
      state.selectedTerritory = payload.name;
      state.selectedEntity = null;
      state.selectedAsset = null;
      state.selectedAssetId = null;
    },

    SET_ENTITY(state, payload) {
      state.selectedEntity = payload.name;
      state.selectedAsset = null;
      state.selectedAssetId = null;
    },

    SET_ASSET(state, payload) {
      state.selectedAsset = payload.name;
      state.selectedAssetId = payload.id;
      state.assetName = payload.name; // Pour affichage dans context-bar
      state.isAssetReady = payload.ready || false;
      // Clear stale simulation results from a previous asset selection
      state.planningData = [];
      state.planningTimestamp = null;
    },

    SET_MODE(state, mode) {
      state.mode = mode;
      state.isModeReady = !!mode;
    },

    ADD_SILO(state, silo) {
      state.silos.push({
        id: Date.now(),
        ...silo,
      });
    },

    UPDATE_SILO(state, { id, updates }) {
      const index = state.silos.findIndex((s) => s.id === id);
      if (index !== -1) {
        state.silos.splice(index, 1, { ...state.silos[index], ...updates });
      }
    },

    REMOVE_SILO(state, id) {
      state.silos = state.silos.filter((s) => s.id !== id);
    },

    CLEAR_SILOS(state) {
      state.silos = [];
    },

    ADD_BOILER(state, boiler) {
      state.boilers.push({
        id: Date.now(),
        priority: state.boilers.length + 1,
        ...boiler,
      });
    },

    UPDATE_BOILER(state, { id, updates }) {
      const index = state.boilers.findIndex((b) => b.id === id);
      if (index !== -1) {
        state.boilers.splice(index, 1, { ...state.boilers[index], ...updates });
      }
    },

    REMOVE_BOILER(state, id) {
      state.boilers = state.boilers.filter((b) => b.id !== id);
      // Recalculer les priorités
      state.boilers.forEach((b, index) => {
        b.priority = index + 1;
      });
    },

    CLEAR_BOILERS(state) {
      state.boilers = [];
    },

    REORDER_BOILERS(state, newOrder) {
      state.boilers = newOrder;
      state.boilers.forEach((b, index) => {
        b.priority = index + 1;
      });
    },

    SET_PILOT(state, { mode, tag, regulationMode, cogenActive, cogenPower }) {
      state.pilotMode = mode;
      state.tagPrevision = tag;
      if (regulationMode !== undefined) state.regulationMode = regulationMode;
      if (cogenActive !== undefined) state.cogenActive = cogenActive;
      if (cogenPower !== undefined) state.cogenPower = cogenPower;
    },

    SET_HEATING_PLANT_ID(state, heatingPlantId) {
      state.heatingPlantId = heatingPlantId;
    },

    SET_CONFIG_COMPLETE(state, value) {
      state.isConfigComplete = value;
    },

    SET_INITIAL_STOCKS(state, stocks) {
      state.initialStocks = stocks;
    },

    ADD_CONSTRAINT(state, constraint) {
      state.constraints.push({
        id: Date.now(),
        ...constraint,
      });
    },

    UPDATE_CONSTRAINT(state, { id, updates }) {
      const index = state.constraints.findIndex((c) => c.id === id);
      if (index !== -1) {
        state.constraints.splice(index, 1, { ...state.constraints[index], ...updates });
      }
    },

    REMOVE_CONSTRAINT(state, id) {
      state.constraints = state.constraints.filter((c) => c.id !== id);
    },

    SET_PLANNING_CONFIG(state, config) {
      state.planningConfig = { ...state.planningConfig, ...config };
    },

    SET_PLANNING_DATA(state, data) {
      state.planningData = data;
    },

    SET_PLANNING_TIMESTAMP(state, timestamp) {
      state.planningTimestamp = timestamp;
    },

    SHOW_NOTIFICATION(state, { message, type = 'info' }) {
      state.notification = {
        show: true,
        message,
        type,
      };
    },

    HIDE_NOTIFICATION(state) {
      state.notification.show = false;
    },

    RESET_WIZARD(state) {
      state.currentStep = 1;
      state.maxStep = 1;
      state.selectedTerritory = null;
      state.selectedEntity = null;
      state.selectedAsset = null;
      state.selectedAssetId = null;
      state.mode = null;
      state.silos = [];
      state.boilers = [];
      state.pilotMode = null;
      state.tagPrevision = null;
      state.initialStocks = [];
      state.constraints = [];
      state.planningData = [];
      state.planningTimestamp = null;
      state.isAssetReady = false;
      state.isModeReady = false;
      state.isConfigComplete = false;
    },
  },

  actions: {
    // Actions pour charger les données depuis l'API
    async loadConfiguration({ commit, state }) {
      try {
        console.log('📥 Loading configuration for asset:', state.selectedAssetId);

        // Récupérer les détails de l'asset depuis l'API
        const assetDetails = await require('@/services/api/assets').getAssetDetails(state.selectedAssetId);

        // L'id de l'asset EST le config_id (Site.config_id = Configuration.id)
        const configId = assetDetails.id;

        if (!configId) {
          console.warn('⚠️ No id found for this asset');
          return { success: false };
        }

        console.log('📥 Loading configuration with configId:', configId);

        // Charger la configuration complète
        const response = await configApi.loadConfiguration(configId);

        if (response) {
          // Vider les silos et boilers actuels
          commit('CLEAR_SILOS');
          commit('CLEAR_BOILERS');

          // Charger les silos
          if (response.silos && response.silos.length > 0) {
            response.silos.forEach((silo) => {
              commit('ADD_SILO', silo);
            });
          }

          // Charger les boilers
          if (response.boilers && response.boilers.length > 0) {
            response.boilers.forEach((boiler) => {
              commit('ADD_BOILER', boiler);
            });
          }

          // Stocker l'ID du HeatingPlant pour la sauvegarde
          if (response.heatingPlantId) {
            commit('SET_HEATING_PLANT_ID', response.heatingPlantId);
            console.log('✅ heatingPlantId stored:', response.heatingPlantId);
          } else {
            console.warn('⚠️ No heatingPlantId in response');
          }

          // Charger le pilot mode
          if (response.pilotMode) {
            const tag = response.pilotMode.tagPrevision ?? '';
            commit('SET_PILOT', {
              mode: response.pilotMode.mode,
              tag,
              regulationMode: response.pilotMode.regulationMode ?? null,
              cogenActive: response.pilotMode.cogenActive ?? null,
              cogenPower: response.pilotMode.cogenPower ?? null,
            });
          }

          // Marquer la config comme complète
          commit('SET_CONFIG_COMPLETE', true);

          console.log('✅ Configuration loaded successfully');
        }

        return { success: true };
      } catch (error) {
        console.error('❌ Error loading configuration:', error);
        commit('SHOW_NOTIFICATION', {
          message: 'Erreur lors du chargement de la configuration',
          type: 'error',
        });
        return { success: false, error };
      }
    },

    async saveConfiguration({ commit, state }) {
      try {
        console.log('🚀 Starting saveConfiguration...');
        console.log('📍 selectedAssetId:', state.selectedAssetId);
        console.log('📍 heatingPlantId:', state.heatingPlantId);

        // Récupérer le config_id depuis l'asset (c'est l'id de l'asset lui-même)
        const assetDetails = await require('@/services/api/assets').getAssetDetails(state.selectedAssetId);
        const configId = assetDetails.id; // Pas config_id, mais id!
        console.log('📍 configId from asset:', configId);
        console.log('📍 hasConfiguration:', assetDetails.hasConfiguration);

        // Si pas de HeatingPlant, utiliser le configId comme heatingPlantId (même UUID)
        let heatingPlantId = state.heatingPlantId;
        if (!heatingPlantId) {
          console.warn('⚠️ No heatingPlantId in state, using configId');
          heatingPlantId = configId;
          commit('SET_HEATING_PLANT_ID', heatingPlantId);
        }

        const configData = {
          silos: state.silos,
          boilers: state.boilers,
          pilotMode: {
            mode: state.pilotMode,
            tagPrevision: state.tagPrevision,
            regulationMode: state.regulationMode,
            cogenActive: state.cogenActive,
            cogenPower: state.cogenPower,
          },
        };

        console.log('💾 Saving configuration:', {
          configId,
          heatingPlantId: heatingPlantId,
          silos: configData.silos.length,
          boilers: configData.boilers.length,
        });

        // POST/PUT vers backend avec les vrais endpoints
        const response = await configApi.saveConfiguration(configId, heatingPlantId, configData);

        if (response.success) {
          commit('SET_CONFIG_COMPLETE', true);
          commit('SHOW_NOTIFICATION', {
            message: 'Configuration sauvegardée avec succès',
            type: 'success',
          });
          console.log('✅ Configuration saved successfully');
          return { success: true, data: response.data };
        } else {
          throw new Error('Save failed');
        }
      } catch (error) {
        console.error('❌ Error saving configuration:', error);
        commit('SHOW_NOTIFICATION', {
          message: 'Erreur lors de la sauvegarde de la configuration',
          type: 'error',
        });
        return { success: false, error };
      }
    },

    async runPrediction({ commit, state }) {
      try {
        const predictionParams = {
          initialStocks: state.initialStocks,
          startDate: state.planningConfig.startDate,
          endDate: state.planningConfig.endDate,
          temperatureScenario: state.planningConfig.temperatureScenario,
          constraints: state.constraints,
          tagPrevision: state.tagPrevision,
        };

        console.log('Running prediction with params:', predictionParams);

        // POST vers backend pour calculer la prévision
        const response = await predictionsApi.runPrediction(state.selectedAssetId, predictionParams);

        if (response.success && response.planningData) {
          commit('SET_PLANNING_DATA', response.planningData);
          commit('SET_PLANNING_TIMESTAMP', new Date().toISOString());
          // Persist results in database for this asset
          if (state.selectedAssetId) {
            try {
              await predictionsApi.saveSimulationResult(state.selectedAssetId, response.planningData);
            } catch (e) {
              console.warn('Could not persist simulation results to database:', e);
            }
          }
          commit('SHOW_NOTIFICATION', {
            message: 'Prévision calculée avec succès',
            type: 'success',
          });
          return { success: true, data: response.planningData };
        } else {
          throw new Error('Prediction failed');
        }
      } catch (error) {
        console.error('Error running prediction:', error);
        commit('SHOW_NOTIFICATION', {
          message: 'Erreur lors du calcul des prévisions',
          type: 'error',
        });
        return { success: false, error };
      }
    },

    async loadLastSimulation({ commit, state }) {
      const assetId = state.selectedAssetId;
      if (!assetId) return;
      try {
        const result = await predictionsApi.getLastSimulationResult(assetId);
        if (Array.isArray(result.planningData) && result.planningData.length > 0) {
          commit('SET_PLANNING_DATA', result.planningData);
          if (result.createdAt) {
            commit('SET_PLANNING_TIMESTAMP', result.createdAt);
          }
          console.log('✅ Last simulation results restored from database for asset:', assetId);
        }
      } catch (e) {
        console.warn('Could not restore simulation results from database:', e);
      }
    },
  },

  getters: {
    canProceedFromStep1: (state) => {
      return state.selectedAsset && state.isAssetReady;
    },

    canProceedFromStep2: (state) => {
      return state.mode !== null;
    },

    canAccessConfigMode: (state) => {
      return state.isAssetReady;
    },

    canAccessPredictionsMode: (state) => {
      return state.isConfigComplete;
    },

    totalSiloCapacity: (state) => {
      return state.silos.reduce((sum, silo) => sum + (parseFloat(silo.capacity) || 0), 0);
    },

    totalBoilerPower: (state) => {
      return state.boilers.reduce((sum, boiler) => sum + (parseFloat(boiler.power) || 0), 0);
    },
  },
};
